import React, { useEffect } from "react";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const Features = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Features</h1>
            <p>
              Discover the powerful features that make Optimus the perfect POS
              solution for your business.
            </p>
          </div>
        </div>
      </section>

      <section className="features-section">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Real-time Analytics</h3>
              <p>
                Get instant insights into your business performance with
                comprehensive dashboards and reports.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Secure & Compliant</h3>
              <p>
                ETIMS compliant with enterprise-grade security to protect your
                business data.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Lightning Fast</h3>
              <p>
                Optimized for speed and performance to keep your business
                running smoothly.
              </p>
            </div>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default Features;
